module.exports = __webpack_public_path__ + "img/PorkSwitzerland.3f3b5e59.png";